import React, { PureComponent } from 'react';
import moment from 'moment';
import { DatePicker } from '@dbk/ui-datepicker';
import { View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Button from '@dbk/ui-buttons';
import Text from '@dbk/ui-text';
import Dropdown from '@dbk/ui-dropdowns';
import { LoadingCircle } from '../../../components/common/loading';
import { FormGroup, Message, Label, TextInput, TextArea } from '@dbk/ui-forms';
import UploadFileButton from './upload-file-button';
import downloadLocalFile from '../../../utils/download-local-file';
import convertToBase64 from '../../../utils/convert-to-base64';
import { PALETTE, TIMELIST, DATE_FORMATS } from '../../../constants';

const uniq = require('lodash/uniq');
const messageMaxLength = 100;

function calculateTimeSelection(selectionStart) {
  if (moment().isSame(selectionStart, 'day')) {
    const utcOffset = moment().utcOffset();
    const singaporeOffset = 480;
    const basetime = moment().utcOffset(utcOffset - singaporeOffset);
    const diff = basetime.diff(moment().startOf('day'), 'hours', true) * 2 + 1;
    return TIMELIST.slice(diff);
  }
  return TIMELIST;

}

function returnListOfDaysTillToday() {
  const startDay = moment().startOf('month').subtract(7, 'days');
  const endDay = moment().subtract(1, 'days');
  const array = [startDay, endDay];
  const numberOfDays = moment(endDay).diff(moment(startDay), 'days');

  for (let i = 1; i < numberOfDays; i++) {
    array.push(moment(startDay).add(i, 'days'));
  }
  return array;
}

class DocUpload extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      file: null,
      isNoFile: false,
      timelist: TIMELIST,
      listOfDisbledDays: returnListOfDaysTillToday(),
      pfId: '',
      userId: '',
      orderId: '',
      documentType: '',
      documentName: '',
      selectedDay: '',
      dueTime: '',
      messageUser: '',
      wrongDate: false,
      errorsState: {
        noEligiblePortfolio: false,
        noPortfolio: false,
        noEligibleUser: false,
        noUser: false,
        noDocumentType: false,
        noDocumentName: false,
        noDueTime: false
      },
      submitStatus: {
        isFailed: false,
        message: ""
      },
    }

    this.convertToDropDown = this.convertToDropDown.bind(this);
    this.changeFile = this.changeFile.bind(this);
    this.onChangePfid = this.onChangePfid.bind(this);
    this.checkPfId = this.checkPfId.bind(this);
    this.checkClientList = this.checkClientList.bind(this);
    this.submitDocument = this.submitDocument.bind(this);
    this.onDayClick = this.onDayClick.bind(this);
    this.onInvalidDay = this.onInvalidDay.bind(this);
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
    const { i18n: { messages }, docsigncenter: { documentUploadStatus } } = this.props;
    if (prevProps.docsigncenter.documentUploadStatus !== documentUploadStatus) {
      if (documentUploadStatus !== undefined) {
        if (documentUploadStatus === true) {
          this.props.updateShouldRequestDocList(true);
          this.props.onCloseModal();
          this.props.confirmationModal();
        } else {
          const errMessage = documentUploadStatus === "error" ? messages['app.digisign.error.tryagain'] : documentUploadStatus;
          // if (documentUploadStatus === "error")
          this.changeFile(null);
          this.setState({
            isLoading: false,
            submitStatus: {
              isFailed: true,
              message: errMessage
            }
          });
        }
        this.props.resetDocumentStatus();
      }
    }
  }

  onDayClick = (selectionStart) => {
    if (moment().isAfter(moment(selectionStart), 'day')) {
      if (this.state.selectedDay === "") {
        this.setState(
          {
            wrongDate: true,
          }
        );
      }
    } else {

      this.setState({
        wrongDate: false,
        selectedDay: selectionStart,
        dueTime: '',
        timelist: calculateTimeSelection(selectionStart)
      });
    }
  }

  onInvalidDay(e) {
    if (this.state.selectedDay === "") {
      this.setState(
        {
          wrongDate: true
        }
      );
    }
  }

  async submitDocument() {
    const {
      auth: { userId }
    } = this.props;

    await this.setState({
      isNoFile: !this.state.file,
      wrongDate: false,
      errorsState: {
        noPortfolio: this.state.errorsState.noEligiblePortfolio ? false : this.state.pfId === '',
        noUser: this.state.errorsState.noEligibleUser ? false : this.state.userId === '',
        noDocumentName: this.state.documentName.trim() === '',
        noDocumentType: this.state.documentType === '',
        noDueTime: this.state.dueTime === '' && this.state.selectedDay
      }
    });

    let isAnyError = false;
    const errorsStateObj = this.state.errorsState;
    for (const prop in errorsStateObj) {
      if (errorsStateObj.hasOwnProperty(prop) && errorsStateObj[prop]) {
        isAnyError = true;
        return;
      }
    }

    if (!isAnyError) {
      const fileContents = await convertToBase64(this.state.file);

      const body = {
        "fileName": this.state.file.name,
        "docByteCode": fileContents,
        "templateType": this.state.documentType,
        "dueDate": this.state.selectedDay ? moment(this.state.selectedDay).format(DATE_FORMATS.date) : null,
        "dueTime": this.state.dueTime,
        "dwoClientId": this.state.userId,
        "docName": this.state.documentName.trim(),
        "dwopFId": this.state.pfId,
        "orderId": this.state.orderId.trim(),
        "uploadUserId": userId,
        "rmMessage": this.state.messageUser.trim()
      }
      this.setState({
        isLoading: true,
        submitStatus: {
          isFailed: false,
          message: ''
        }
      });
      this.props.passDocumentForUpload(body);
    }
  }

  convertToDropDown(values, ...keys) {
    if (values && values.length && keys.length) {
      if (keys.length === 1) { // no label key, only value key
        return values.map(e => ({
          label: e,
          value: e
        }));
      } // got label key also
      return values.map(e => ({
        label: `${e[keys[1]]}`,
        value: `${e[keys[0]]}`
      }));
    }
    return [];
  }

  onChangePfid(option) {
    this.props.getEligibleClientList(option);
    this.setState({ userId: '' });
  }

  onFilterChange = (key, value, errorsStateKey) => {
    const errorsStateObj = this.state.errorsState;
    if (errorsStateKey) {
      if (errorsStateKey === "noPortfolio") {
        errorsStateObj[errorsStateKey] = this.state.errorsState.noEligiblePortfolio ? false : (value === "" || value === null);
      } else if (errorsStateKey === "noUser") {
        errorsStateObj[errorsStateKey] = this.state.errorsState.noEligiblePortfolio ? false : (value === "" || value === null);
      } else {
        errorsStateObj[errorsStateKey] = (value === "" || value === null);
      }
    }

    this.setState(
      {
        [key]: value,
        errorsState: errorsStateObj
      }
    );
  };

  async changeFile(file) {
    await this.setState({
      file,
      isNoFile: false
    });
  }



  async checkPfId(pfIdList) {
    const errorsStateObj = this.state.errorsState;
    if (pfIdList === "" || pfIdList === "empty") {
      errorsStateObj.noEligiblePortfolio = true;
      await this.setState({
        errorsState: errorsStateObj
      });
      return false;
    }
    return true;
  }

  async checkClientList(clientList) {
    const errorsStateObj = this.state.errorsState;
    if (clientList === "") {
      errorsStateObj.noEligibleUser = true;
      await this.setState({
        errorsState: errorsStateObj
      });
      return false;
    }
    return true;
  }

  render() {
    const {
      i18n: { messages },
      docsigncenter: { documentTypeList, eligiblePfList, eligibleClientList },
    }
      = this.props;

    let portfolioIdList = [];
    let documentTypeListArray = [];
    let userNameList = [];

    if (eligiblePfList !== undefined) {
      this.checkPfId(eligiblePfList);
    }
    if (eligibleClientList !== undefined) {
      this.checkClientList(eligibleClientList);
    }

    documentTypeListArray = documentTypeList && this.convertToDropDown(documentTypeList, "templateSid", "templateName")
    portfolioIdList = eligiblePfList && this.checkPfId(eligiblePfList) && this.convertToDropDown(uniq(eligiblePfList.pfId), "pfId");
    userNameList = eligibleClientList && this.checkClientList(eligibleClientList) && this.convertToDropDown(eligibleClientList, "userId", "userName")

    const portfolioIdDropdownCSS = this.state.errorsState.noEligiblePortfolio || this.state.errorsState.noPortfolio ? 'input-field-dimensions input-error-state' : 'input-field-dimensions';
    const clientNameDropdownCSS = this.state.errorsState.noEligibleUser || this.state.errorsState.noUser ? 'input-field-dimensions input-error-state' : 'input-field-dimensions';
    const documentTypeDropdownCSS = this.state.errorsState.noDocumentType ? 'input-field-dimensions input-error-state' : 'input-field-dimensions';

    return (
      <div>
        {this.state.isLoading &&
          < div testID="docSignCenter-modal-container" className="docsigncenter" >
            <div className="row">
              <div className="columns text-center large-12 margin-bottom-30">
                <Text testID="docSignCenter-modal-container-heading" secondary>{messages['app.docsigncenter.uploadDoc.inprogress']}</Text>
              </div>
            </div>

            <LoadingCircle />
          </div>

        }
        {!this.state.isLoading &&
          < div testID="docSignCenter-modal-container" className="docsigncenter" >

            <div className="row">
              <div className="columns large-12 ">
                <Text testID="docSignCenter-modal-container-heading" secondary>{messages['app.docsigncenter.uploadDoc.instructions']}</Text>
              </div>
            </div>
            <div className="row">
              <UploadFileButton
                file={this.state.file}
                onChangeFile={this.changeFile}
                missingFile={this.state.isNoFile} />
            </div>
            <div className="row">
              <div className="columns large-12 ">
                <FormGroup>
                  <div >
                    <Label testID="docSignCenter-modal-container-portfolioId-text">{messages['app.docsigncenter.uploadDoc.portfolioId.label']}</Label>
                  </div>
                  <div className='input-field-container'>
                    <Dropdown
                      testID="docSignCenter-modal-container-portfolioId-dropdown"
                      className={`${portfolioIdDropdownCSS} no-hover`}
                      size='large'
                      selected={this.state.pfId}
                      options={portfolioIdList}
                      defaultLabel={messages['app.docsigncenter.uploadDoc.portfolioId.placeholder']}
                      onChange={(option) => {
                        this.onFilterChange('pfId', option, 'noPortfolio');
                        this.onChangePfid(option);
                      }}
                    />
                    <Message testID="docSignCenter-modal-container-portfolioId-error" type="error">
                      {this.state.errorsState.noEligiblePortfolio && messages['app.docsigncenter.uploadDoc.noEligiblePortfolio']}
                      {this.state.errorsState.noPortfolio && messages['app.docsigncenter.uploadDoc.noPortfolio']}
                    </Message>
                  </div>
                </FormGroup>
              </div>
            </div>

            <div className="row">
              <div className="columns large-12 ">
                <div >
                  <Label testID="docSignCenter-modal-container-userName-text">{messages['app.docsigncenter.uploadDoc.userName.label']}</Label>
                </div>
                <div className='input-field-container'>
                  <Dropdown
                    testID="docSignCenter-modal-container-userName-dropdown"
                    className={`${clientNameDropdownCSS} no-hover`}
                    size="large"
                    options={userNameList}
                    selected={this.state.userId}
                    defaultLabel={messages['app.docsigncenter.uploadDoc.userName.placeholder']}
                    onChange={(option) => {
                      this.onFilterChange('userId', option, 'noUser');
                    }}
                  />
                  <Message testID="docSignCenter-modal-container-userName-error" type="error">
                    {this.state.errorsState.noEligibleUser && messages['app.docsigncenter.uploadDoc.noEligibleUser']}
                    {this.state.errorsState.noUser && messages['app.docsigncenter.uploadDoc.noUser']}
                  </Message>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns large-12 ">
                <div>
                  <Label testID="docSignCenter-modal-container-orderId-text">{messages['app.docsigncenter.uploadDoc.orderId.label']}{' '}
                    {messages['app.docsigncenter.uploadDoc.optional']}
                  </Label>
                </div>
                <div className='input-field-container'>
                  <TextInput
                    testID="docSignCenter-modal-container-orderId-textInput"
                    className='input-field-dimensions'
                    size="small"
                    maxlength={15}
                    placeholder={messages['app.docsigncenter.uploadDoc.orderId.placeholder']}
                    placeholderTextColor={PALETTE.primaryText}
                    value={this.state.orderId}
                    onChange={text => this.onFilterChange('orderId', text.target.value)}
                  />
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns large-12">
                <div >
                  <Label testID="docSignCenter-modal-container-documentType-text">{messages['app.docsigncenter.uploadDoc.documentType.label']}</Label>
                </div>
                <div className='input-field-container'>
                  <Dropdown
                    testID="docSignCenter-modal-container-documentType-dropdown"
                    className={`${documentTypeDropdownCSS} no-hover`}
                    size='large'
                    options={documentTypeListArray}
                    selected={this.state.documentType}
                    defaultLabel={messages['app.docsigncenter.uploadDoc.documentType.placeholder']}
                    onChange={(option) => {
                      this.onFilterChange('documentType', option, 'noDocumentType');
                    }}
                  />
                  <Message testID="docSignCenter-modal-container-documentType-error" type="error">
                    {this.state.errorsState.noDocumentType && messages['app.docsigncenter.uploadDoc.noDocumentType']}
                  </Message>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns large-12 ">
                <div >
                  <Label testID="docSignCenter-modal-container-documentName-text">{messages['app.docsigncenter.uploadDoc.documentName.label']}</Label>
                </div>
                <div className='input-field-container'>
                  <TextInput
                    testID="docSignCenter-modal-container-documentName-textInput"
                    className='input-field-dimensions'
                    size="small"
                    maxlength={15}
                    placeholder={messages['app.docsigncenter.uploadDoc.documentName.placeholder']}
                    value={this.state.documentName}
                    error={this.state.errorsState.noDocumentName}
                    onChange={text => this.onFilterChange('documentName', text.target.value, 'noDocumentName')}
                  />
                  <Message testID="docSignCenter-modal-container-documentName-error" type="error">
                    {this.state.errorsState.noDocumentName && messages['app.docsigncenter.uploadDoc.noDocumentName']}
                  </Message>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns large-8 ">
                <div >
                  <Label testID="docSignCenter-modal-container-dueDate-text">{messages['app.docsigncenter.uploadDoc.dueDate.label']}</Label>
                </div>
                <div className='input-field-container'>

                  <DatePicker
                    onChange={(option) => {
                      this.onDayClick(option);
                    }}
                    value={this.state.selectedDay}
                    startDate={moment().add(-1, 'months')}
                    selectionStart={this.state.selectedDay}
                    inputDateFormat={'DD MMM YYYY'}
                    error={this.state.wrongDate}
                    disabledDays={
                      {
                        from: moment().startOf('month').subtract(7, 'days'),
                        to: moment().subtract(1, 'days')
                      }}
                    onInvalidDate={this.onInvalidDay}
                  />

                  <Message testID="docSignCenter-modal-container-dueDate-error" type="error">
                    {this.state.wrongDate && "Please enter valid date"}
                  </Message>
                </div>
              </div>
              <div className="columns large-4 ">
                <div >
                  <Label testID="docSignCenter-modal-container-time-text">{messages['app.docsigncenter.uploadDoc.time.label']}</Label>
                </div>
                <div className='input-field-container'>
                  <Dropdown
                    testID="docSignCenter-modal-container-time-dropdown"
                    className={this.state.errorsState.noDueTime ? 'input-field-dimensions input-error-state' : 'input-field-dimensions'}
                    size="large"
                    disabled={this.state.selectedDay === '' ? true : false}
                    options={this.state.timelist}
                    selected={this.state.dueTime}
                    onChange={(option) => {
                      this.onFilterChange('dueTime', option, 'noDueTime');
                    }}
                    defaultLabel={messages['app.docsigncenter.uploadDoc.time.label']}
                  />
                  <Message testID="docSignCenter-modal-container-dueDate-error" type="error">
                    {this.state.errorsState.noDueTime && this.state.selectedDay &&
                      messages['app.docsigncenter.uploadDoc.noDueTime']}
                  </Message>
                  <Message testID="docSignCenter-modal-container-dueDate-error" type="neutral">
                    {messages['app.docsigncenter.uploadDoc.time.instructions']}
                  </Message>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="columns large-12 ">
                <div >
                  <Label testID="docSignCenter-modal-container-message-text">{messages['app.docsigncenter.uploadDoc.message.label']}{' '}
                    {messages['app.docsigncenter.uploadDoc.optional']}</Label>
                </div>
                <div className='input-field-container'>
                  <TextArea
                    testID="docSignCenter-modal-container-message-textArea"
                    className='input-field-dimensions'
                    maxlength={messageMaxLength}
                    size="small"
                    placeholder={messages['app.docsigncenter.uploadDoc.message.placeholder']}
                    value={this.state.messageUser}
                    onChange={text => this.onFilterChange('messageUser', text.target.value)}
                  />
                  <div>
                    {this.state.messageUser.length === 0 ?
                      <div className='char-count'>
                        <Label>(0/{messageMaxLength})</Label>
                      </div>
                      :
                      <div className='char-count'>
                        <Label>({this.state.messageUser.length} /{messageMaxLength})</Label>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="btn">
                <Button size='large' testID="docSignCenter-modal-container-submitButton"
                  onClick={() => this.submitDocument()}
                >
                  {messages['app.rating.submit']}
                </Button>
              </div>
              <div className="btn">
                <Button size='large' testID="docSignCenter-modal-container-cancelButton"
                  tertiary
                  onClick={() => this.props.onCloseModal()} >
                  {messages['app.profile.changeLanguage.cancelText']}
                </Button>
              </div>
              <div className="btn">
                <Button
                  size='large' testID="docSignCenter-modal-container-viewButton"
                  tertiary
                  disabled={!this.state.file}
                  onClick={() => downloadLocalFile(this.state.file)}
                >
                  {messages['app.docsigncenter.uploadDoc.viewDoc']}
                </Button>
              </div>
              <div className="btn">
                <Message testID="docSignCenter-modal-container-submit-error" type="error">
                  {this.state.submitStatus.isFailed && this.state.submitStatus.message}
                </Message>
              </div>
            </div>
          </div >}
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    app: {
      config: {
        apiverion: true
      }
    },
    changePage: { $call: 'ui.history.push' },
    i18n: {
      messages: true,
    },
    auth: {
      userId: true
    },
    settings: {
      defaultEnvironment: true
    },
    getEligibleClientList: { $call: 'docsigncenter.getEligibleClientList' },
    passDocumentForUpload: { $call: 'docsigncenter.uploadDocument' },
    resetDocumentStatus: { $call: 'docsigncenter.resetDocumentStatus' },
    updateShouldRequestDocList: { $call: 'docsigncenter.updateShouldRequestDocList' },
    docsigncenter: {
      documentTypeList: true,
      eligiblePfList: true,
      eligibleClientList: true,
      documentUploadStatus: true,
    }
  }
})(DocUpload);

export { DocUpload };
